import TreeBox from './treedata.vue';
import TreeBoxBase from './treedatabase.vue';
export {TreeBox,TreeBoxBase};


// WEBPACK FOOTER //
// ./src/components/tree/index.js